import React, { createContext, useContext } from "react";

let operationsAllowed: any = {};
const HomeRepositoryContext = createContext(operationsAllowed);

export const HomeRepositoryProvider = (props: any) => {
  // const client = useApolloClient();

  const getNotifications = () => {
    //
  };

  operationsAllowed = {
    getNotifications,
  };

  return (
    <HomeRepositoryContext.Provider value={operationsAllowed}>
      {props.children}
    </HomeRepositoryContext.Provider>
  );
};

export const useHomeRepository = () => {
  return useContext(HomeRepositoryContext);
};
